import { BCMSAsset } from "bcms-react";

// SVG Imports
import { ReactComponent as ArrowDownloadIcon } from "res/img/ArrowDownloadIcon.svg";
import { ReactComponent as ArrowSquareIcon } from "res/img/ArrowSquareIcon.svg";
import { ReactComponent as CameraIcon } from "res/img/CameraIcon.svg";
import { ReactComponent as CircleProfileIcon } from "res/img/CircleProfileIcon.svg";
import { ReactComponent as DollarSignIcon } from "res/img/DollarSignIcon.svg";
import { ReactComponent as EqualHousingLenderIcon } from "res/img/EqualHousingLenderIcon.svg";
import { ReactComponent as EyeIcon } from "res/img/EyeIcon.svg";
import { ReactComponent as FaceIDIcon } from "res/img/FaceIDIcon.svg";
import { ReactComponent as HideEyeIcon } from "res/img/HideEyeIcon.svg";
import { ReactComponent as LeftChevronIcon } from "res/img/LeftChevronIcon.svg";
import { ReactComponent as LocationPinIcon } from "res/img/LocationPinIcon.svg";
import { ReactComponent as NCUAIcon } from "res/img/NCUAIcon.svg";
import { ReactComponent as OppositeArrowsIcon } from "res/img/OppositeArrowsIcon.svg";
import { ReactComponent as PhoneIcon } from "res/img/PhoneIcon.svg";
import { ReactComponent as PlusPersonIcon } from "res/img/PlusPersonIcon.svg";
import { ReactComponent as RightChevronIcon } from "res/img/RightChevronIcon.svg";
import { ReactComponent as XIcon } from "res/img/XIcon.svg";
import { ReactComponent as ZelleLogoIcon } from "res/img/ZelleLogoIcon.svg";
import { ReactComponent as WalletIcon } from "res/img/WalletIcon.svg";
import { ReactComponent as CardIcon } from "res/img/CardIcon.svg";
import { ReactComponent as DollarSignOutlineIcon } from "res/img/DollarSignOutlineIcon.svg";
import { ReactComponent as FDICIcon } from "res/img/FDICIcon.svg";
import MyFinancialLogo from "res/img/myFinancialLogo740x200.png";
import FDICDigitalSignWhite from "res/img/fdic-digital-sign-white.png";
import FDICDigitalSign from "res/img/fdic-digital-sign.png";

// IMG ImportsDollarSignOutlineIcon
const assets = {
	// SVG Exports
	"ArrowDownloadIcon" : ArrowDownloadIcon,
	"ArrowSquareIcon" : ArrowSquareIcon,
	"CameraIcon" : CameraIcon,
	"CircleProfileIcon" : CircleProfileIcon,
	"DollarSignIcon" : DollarSignIcon,
	"EqualHousingLenderIcon" : EqualHousingLenderIcon,
	"EyeIcon" : EyeIcon,
	"FaceIDIcon" : FaceIDIcon,
	"HideEyeIcon" : HideEyeIcon,
	"LeftChevronIcon" : LeftChevronIcon,
	"LocationPinIcon" : LocationPinIcon,
	"NCUAIcon" : NCUAIcon,
	"OppositeArrowsIcon" : OppositeArrowsIcon,
	"PhoneIcon" : PhoneIcon,
	"PlusPersonIcon" : PlusPersonIcon,
	"RightChevronIcon" : RightChevronIcon,
	"XIcon" : XIcon,
	"ZelleLogoIcon" : ZelleLogoIcon,
	"WalletIcon" : WalletIcon,
	"CardIcon" : CardIcon,
	"DollarSignOutlineIcon" : DollarSignOutlineIcon,
	"FDICIcon" : FDICIcon,
	// IMG Exports
	"MyFinancialLogo": MyFinancialLogo,
	"FDICDigitalSignWhite" : FDICDigitalSignWhite,
	"FDICDigitalSign" : FDICDigitalSign
}
const { image, svg } = BCMSAsset.init(assets).loadAsset();

// Export a function for images
export function ImageAsset(props){ 
	return (<> { image(props.id, props) } </>); 
}

// Export a function for svgs
export function SVGAsset(props){ 
	
	if(assets[props.id]){
		return (<> { svg(props.id, { ...props, className: `${ props.className ?? "" } icon` }) } </>); 
	}
	return <span className={(props.className?props.className:"material-symbols-outlined material-icon-outlined md-14") +"  icon"}>{props.id}</span>
	
}